<div class="lum-modal">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading || false"
    [classes]="'loading blur'"
  ></div>
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">Kit Components</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <form
      [formGroup]="form"
      class="invoice-note-form__wrapper"
      (submit)="onSubmit()"
    >
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="">Kit SKU</label>
            <div>
              <strong>{{ data.kit.sku }}</strong>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label for="">Kit Product Name</label>
            <div>
              <strong>{{ data.kit.product_name }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="">Kit Quantity</label>
            <input
              type="number"
              inputmode="numeric"
              class="lum-input"
              formControlName="quantity"
              matInput
              (input)="onQuantityChange($event)"
              [ngClass]="{
                error: form.get('quantity')?.invalid,
              }"
              lumDecimalLimit
            />
            <mat-error *ngIf="form.get('quantity')?.invalid">
              <small>{{ form.get('quantity') | validateField }}</small>
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="!loading">
        <div class="col-12">
          <mat-error *ngIf="form.get('items')?.invalid">
            *Kit must contain 1 or more rfq components
          </mat-error>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div formArrayName="items">
            <table class="lum-table lum-table--classic striped">
              <thead>
                <tr>
                  <th class="w-p35">SKU</th>
                  <th class="w-35">Quantity</th>
                  <th class="w-p25">Unit</th>
                </tr>
              </thead>
              <tbody>
                <ng-container
                  *ngFor="let item of itemsFormArray?.controls; let idx = index"
                >
                  <tr [formGroupName]="idx">
                    <td>
                      {{ item.value.sku }}
                    </td>
                    <td>
                      <input
                        type="number"
                        inputmode="numeric"
                        class="lum-input"
                        formControlName="quantity"
                        matInput
                        [ngClass]="{
                          error: item.get('quantity')?.invalid,
                        }"
                        lumDecimalLimit
                      />
                      <mat-error *ngIf="item.get('quantity')?.invalid">
                        <small>{{ form.get('quantity') | validateField }}</small>
                      </mat-error>
                    </td>
                    <td>
                      <mat-select class="lum-select" formControlName="uomId">
                        <mat-option
                          *ngFor="
                            let unit of item.value?.product?.unitOfMeasures || []
                          "
                          [value]="unit.id"
                        >
                          {{ unit.name }}
                        </mat-option>
                      </mat-select>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="lum-modal__footer">
        <div class="flex ml-auto lum-modal__action">
          <button
            mat-button
            type="submit"
            class="lum-button"
            [disabled]="form.invalid"
          >
            <lum-ui-icon
              class="mr-2"
              icon="add-1"
              color="#ffffff"
              width="16"
              height="16"
            ></lum-ui-icon>
            Add Kit Components
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
